export const colors = {
  backgroundWhite: '#f3eee9',
  pureWhite: '#ffffff',
  // Font colors
  mineshaft: '#101010',
  secondaryMineShaft: '#686765',
  white: '#fcfcfc',
  black: '#191919',
  darkBlack: '#000000',
  satinGrey: '#d4d1ce',
  // Touch
  skyBlue: '#d1efff',
  skyBlue60: '#d1efffa6',
  pink: '#ffd2ea',
  pink60: '#ffd2eaa6',
  yellow: '#ffe583',
  yellow60: '#ffe583a6',
  orange: '#fed7aa',
  orange60: '#fed7aaa6',
  // Action
  blue: '#2867b2',
  green: '#58d458'
};
